import React, { useContext } from "react";
import { OrderPreviewPreparationStatusName } from "../../../../../../../App/pages/Organization/pages/Sales/pages/Orders/services/types";
import { OrderContext } from "../../../../contexts/OrderContext";
import OrderPreparationStatus from "./OrderPreparationStatus";

const OrderPreparationStatuses = () => {
	const { order } = useContext(OrderContext);

	if (!order?.preparation_status_changes) return <></>;

	const { preparation_status_changes } = order;

	const getAllPossibleStatuses = () => {
		const possibleStatuses: OrderPreviewPreparationStatusName[] = [];

		if (preparation_status_changes?.created_at) {
			possibleStatuses.push(OrderPreviewPreparationStatusName.NEW);
		}
		if (preparation_status_changes?.accepted_at && order.number.startsWith("E")) {
			possibleStatuses.push(OrderPreviewPreparationStatusName.ACCEPTED);
		}
		if (preparation_status_changes?.in_progress_supported) {
			possibleStatuses.push(OrderPreviewPreparationStatusName.IN_PROGRESS);
		}
		if (preparation_status_changes?.ready_supported) {
			possibleStatuses.push(OrderPreviewPreparationStatusName.READY);
		}
		if (preparation_status_changes?.received_supported) {
			possibleStatuses.push(OrderPreviewPreparationStatusName.RECEIVED);
		}
		if (preparation_status_changes?.delivered_supported) {
			possibleStatuses.push(OrderPreviewPreparationStatusName.DELIVERED);
		}

		return possibleStatuses;
	};

	const getStatusValue = (status: OrderPreviewPreparationStatusName) => {
		switch (status) {
			case OrderPreviewPreparationStatusName.ACCEPTED:
				return preparation_status_changes?.accepted_at;
			case OrderPreviewPreparationStatusName.PACKED:
				return preparation_status_changes?.packed_at;
			case OrderPreviewPreparationStatusName.RECEIVED:
				return preparation_status_changes?.received_at;
			case OrderPreviewPreparationStatusName.IN_PROGRESS:
				return preparation_status_changes?.in_progress_at;
			case OrderPreviewPreparationStatusName.DELIVERED:
				return preparation_status_changes?.delivered_at;
			case OrderPreviewPreparationStatusName.NEW:
				return preparation_status_changes?.created_at;
			case OrderPreviewPreparationStatusName.READY:
				return preparation_status_changes?.ready_at;
			default:
				return undefined;
		}
	};

	const possibleStatuses = getAllPossibleStatuses();

	const isCurrentStatus = (index: number, value: string | undefined) => {
		const previousStatusValue = getStatusValue(possibleStatuses[index - 1]);
		const nextStatusValue = getStatusValue(possibleStatuses[index + 1]);

		return !value && !!previousStatusValue && !nextStatusValue;
	};

	return (
		<div className="order-delivery-preparation-statuses">
			{possibleStatuses.map((status, index) => {
				const value = getStatusValue(status);
				return (
					<OrderPreparationStatus
						key={status}
						status={status}
						value={value}
						lastElement={index === possibleStatuses.length - 1}
						current={isCurrentStatus(index, value)}
					/>
				);
			})}
		</div>
	);
};

export default OrderPreparationStatuses;
